/* @flow */

import { isPluginEnabled } from 'plugin/base/util/pluginUtils';
import useEvent from 'src/shared/domain/event/hook/useEvent';

export default function usePlugin(id: string): boolean {
  return isPluginEnabled(id, useEvent());
}
